<template>
  <div>
    <v-container fluid>
      <v-skeleton-loader
        :loading="!flagNav"
        transition="scale-transition"
        max-height="64"
        type="table-heading">
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">
            {{ $t("ReportFeedback") }}
          </v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>

      <v-card class="reportdata-card-main" style="margin-top: 1rem">
        <v-card-title class="d-flex align-center justify-space-between mb-4">
          <div class="d-flex align-center">
            <v-icon color="primary" class="mr-3" size="28">
              mdi-comment-text-outline
            </v-icon>
            <h3 class="text-h5 font-weight-bold text-primary">
              Feedback Report Management
            </h3>
          </div>
        </v-card-title>

        <v-card-text style="padding: 0">
          <!-- Main Filter Row -->
          <v-row class="mb-4">
            <!-- Date Range Section -->
            <v-col cols="12" md="8">
              <div class="reportdata-filter-section">
                <h4 class="reportdata-section-title mb-3">
                  <v-icon class="mr-2 ml-2" color="primary" size="20">
                    mdi-calendar-range
                  </v-icon>
                  Date Range
                </h4>
                <v-row class="mx-4">
                  <v-col cols="5">
                    <v-card variant="outlined" class="reportdata-card-outlined">
                      <v-card-text class="pa-3">
                        <v-menu
                          v-model="startDateFlag"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          location="bottom"
                          min-width="auto">
                          <template #activator="{ props }">
                            <v-text-field
                              id="startdate-field-reportfeedback"
                              v-model="startDate"
                              label="Start Date"
                              prepend-inner-icon="mdi-calendar"
                              readonly
                              no-details
                              variant="outlined"
                              clearable
                              density="comfortable"
                              class="reportdata-field-date"
                              color="primary"
                              v-bind="props"></v-text-field>
                          </template>
                          <v-date-picker
                          no-details
                            id="startdate-datapicker-reportfeedback"
                            v-model="startDate"
                            :max="endDate != null ? endDate : null"
                            color="primary"
                            @update:model-value="
                              (val) => {
                                startDate = formatDate(val);
                                startDateFlag = false;
                              }
                            "></v-date-picker>
                        </v-menu>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="2" class="d-flex align-center justify-center">
                    <v-icon color="grey-darken-2" size="24">
                      mdi-arrow-right
                    </v-icon>
                  </v-col>

                  <v-col cols="5">
                    <v-card variant="outlined" class="reportdata-card-outlined">
                      <v-card-text class="pa-3">
                        <v-menu
                          v-model="endDateFlag"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          location="bottom"
                          min-width="auto">
                          <template #activator="{ props }">
                            <v-text-field
                              id="enddate-field-reportfeedback"
                              v-model="endDate"
                              label="End Date"
                              prepend-inner-icon="mdi-calendar"
                              readonly
                              variant="outlined"
                              clearable
                              density="comfortable"
                              class="reportdata-field-date"
                              color="primary"
                              v-bind="props"></v-text-field>
                          </template>
                          <v-date-picker
                            id="enddate-datapicker-reportfeedback"
                            v-model="endDate"
                            :min="startDate != null ? startDate : null"
                            color="primary"
                            @update:model-value="
                              (val) => {
                                endDate = formatDate(val);
                                endDateFlag = false;
                              }
                            "></v-date-picker>
                        </v-menu>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
            </v-col>

            <!-- Action Buttons Section -->
            <v-col cols="12" md="4">
              <div class="reportdata-filter-section">
                <h4 class="reportdata-section-title mb-3">
                  <v-icon class="mr-2" color="primary" size="20">
                    mdi-cog
                  </v-icon>
                  Actions
                </h4>
                <v-card variant="outlined" class="mx-4" style="background-color: transparent !important;border-color: transparent !important;">
                  <v-card-text class="pa-3">
                    <div
                      class="d-flex justify-space-between align-center pa-">
                      <v-btn
                        color="primary"
                        variant="elevated"
                        size="large"
                        @click="Search()"
                        class="reportdata-btn-search"
                        prepend-icon="mdi-magnify">
                        SEARCH
                      </v-btn>
                      <v-btn
                        id="button-download-reportfeedback"
                        color="success"
                        variant="elevated"
                        size="large"
                        @click="ExportReportFeedback()"
                        class="reportdata-btn-download"
                        prepend-icon="mdi-download">
                        Download
                      </v-btn>
                    </div>
                  </v-card-text>
                </v-card>
              </div>
            </v-col>
          </v-row>

          <!-- Charts Section -->
          <v-row class="mb-4">
            <v-col cols="12">
              <div class="reportdata-filter-section">
                <h4 class="reportdata-section-title mb-3">
                  <v-icon class="mr-2 ml-2" color="primary" size="20">
                    mdi-chart-pie
                  </v-icon>
                  Feedback Analytics
                </h4>
              </div>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-card class="reportdata-feedback-chart-card">
                <v-card-title class="text-h6 pa-4">
                  <v-icon class="mr-2" color="primary">mdi-chart-pie</v-icon>
                  Like/Dislike Distribution
                </v-card-title>
                <v-card-text class="pa-2">
                  <highcharts :options="chartPie"></highcharts>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-card class="reportdata-feedback-chart-card">
                <v-card-title class="text-h6 pa-4">
                  <v-icon class="mr-2" color="primary">mdi-chart-bar</v-icon>
                  Feedback by Model
                </v-card-title>
                <v-card-text class="pa-2">
                  <highcharts :options="chartColumn"></highcharts>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <!-- Data Table Section -->
          <v-card class="reportdata-card-table">
            <v-card-title
              class="d-flex align-center justify-space-between pa-4">
              <div class="d-flex align-center">
                <v-icon class="mr-2" color="primary">mdi-table</v-icon>
                <span class="text-h6 font-weight-medium">
                  Report Feedback Table ({{ dataTableFeedback.length }} records)
                </span>
              </div>
              <v-checkbox
                v-model="CheckboxShowAllText"
                :label="`${$t('_ShowAllText')}: ${
                  CheckboxShowAllText
                    ? $t('_ShowAllTextOn')
                    : $t('_ShowAllTextOff')
                }`"
                density="compact"
                hide-details></v-checkbox>
            </v-card-title>

            <div class="reportdata-table-container">
              <v-data-table-server
                v-model:options="options"
                :headers="headers"
                :items="dataTableFeedback"
                :items-per-page="itemsPerPage"
                :items-length="searchTotalTable"
                :footer-props="{
                  'items-per-page-options': [5, 10, 25, 50, 100],
                }"
                class="reportdata-table-modern reportdata-feedback-table"
                density="comfortable"
                hover>
                <template #item="{ item }">
                  <tr class="reportdata-table-row">
                    <td class="text-center">
                      {{ item.no }}
                    </td>
                    <td>
                      <div class="reportdata-feedback-text-container">
                        <span class="reportdata-text-standard">
                          {{ item.text }}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div class="reportdata-feedback-answer-container">
                        <div
                          class="reportdata-feedback-answer-content"
                          :class="{ expanded: item.show }">
                          <span
                            class="reportdata-text-standard"
                            v-html="substringLong(item.replymsg)"></span>
                        </div>
                        <v-btn
                          icon
                          size="small"
                          variant="text"
                          @click="item.show = !item.show"
                          class="reportdata-feedback-toggle-btn">
                          <v-icon size="20">
                            {{
                              item.show ? "mdi-chevron-up" : "mdi-chevron-down"
                            }}
                          </v-icon>
                        </v-btn>
                      </div>
                    </td>
                    <td class="text-center">
                      <v-chip
                        size="small"
                        :color="item.scores === 1 ? 'success' : 'error'"
                        :prepend-icon="
                          item.scores === 1 ? 'mdi-thumb-up' : 'mdi-thumb-down'
                        "
                        variant="flat">
                        {{ getScoreLabel(item.scores) }}
                      </v-chip>
                    </td>
                    <td>
                      <div class="reportdata-feedback-text-container">
                        <span class="reportdata-text-standard">
                          {{ item.comments }}
                        </span>
                      </div>
                    </td>
                  </tr>
                </template>
              </v-data-table-server>
            </div>
          </v-card>
        </v-card-text>
      </v-card>
    </v-container>

    <v-overlay :model-value="loading" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";
import dateUtils from "../plugins/date-utils";
import moment from "moment";
export default {
  name: "ReportFeedback",
  inject: ["flagNav","FontColorTitle","SubNavbarBackGround"],
  data: () => ({
    // isChartOptions: false,
    isInitialized: false,
    today: null,
    startDateFlag: false,
    endDateFlag: false,
    startDate: null,
    endDate: null,
    isSearch: false,
    isFirst: true,
    loading: false,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    dataTableFeedback: [],
    itemsPerPage: 10,
    totalTable: 0,
    searchTotalTable: 0,
    sortBy: [],
    sortDesc: [],
    // loadingCard: false,
    chartPie: {
      chart: { type: "pie" },
      title: { text: "Like/Dislike" },
      tooltip: { valueSuffix: "%", footerFormat: "</table>" },
      credits: { enabled: false },
      plotOptions: {
        series: [
          {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: [{ enabled: false, distance: 50 }],
          },
        ],
      },
      series: [
        {
          name: "Percentage",
          colorByPoint: true,
          data: [
            { name: "Like", y: 50 },
            { name: "Dislike", y: 50 },
          ],
        },
      ],
    },
    chartColumn: {
      chart: { type: "column" },
      title: { text: "Like/Dislike" },
      credits: { enabled: false },
      //แต่ละ model
      xAxis: { categories: [], crosshair: true },
      yAxis: { min: 0, title: { text: "Number of feedback" } },
      tooltip: { valueSuffix: "", footerFormat: "</table>" },
      series: [
        { name: "Like", data: [] },
        { name: "Dislike", data: [] },
      ],
    },
    ShowAllText: false,
    CheckboxShowAllText: false,
  }),
  components: {
    highcharts: Chart,
  },
  watch: {
    options: {
      handler() {
        if (!this.isInitialized) return;
        this.GetTableReportFeedback();
      },
      deep: true,
    },
    CheckboxShowAllText(newVal) {
      let self = this;
      if (newVal) {
        self.ShowAll();
      } else {
        self.CloseShowAll();
      }
    },
  },
  methods: {
    formatDate(dateInput) {
      if (!dateInput) {
        return "";
      }
      if (
        typeof dateInput === "string" &&
        /^\d{4}-\d{2}-\d{2}$/.test(dateInput)
      ) {
        return dateInput;
      }

      const d = new Date(dateInput);
      if (isNaN(d.getTime())) {
        return dateInput.toString().substr(0, 10);
      }

      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const date = `${year}-${month}-${day}`;
      return date;
    },
    Search() {
      let self = this;
      self.loading = true;
      self.isSearch = true;
      self.isFirst = true;
      self.GetTableReportFeedback();
    },
    getScoreLabel(scores) {
      return scores === 1 ? "Like" : "Dislike";
    },
    GetTableReportFeedback() {
      let self = this;
      self.loading = true;
      if (self.startDate != null && self.endDate != null) {
        const { page, itemsPerPage } = self.options;
        let temp = {
          page: self.isSearch ? 1 : page,
          perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
          StartDate: self.startDate,
          EndDate: self.endDate,
        };
        self.$call.GetTableReportFeedback(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              if (dataResponse.data.total > 0) {
                self.searchTotalTable = dataResponse.data.total;
                self.dataTableFeedback = dataResponse.data.data;
                self.totalTable = self.isFirst
                  ? dataResponse.data.total
                  : self.totalTable;
                self.options.page = temp.page;
                self.chartPie.series[0].data = dataResponse.data.pie;
                self.chartColumn.series = dataResponse.data.column.information;
                self.chartColumn.xAxis.categories =
                  dataResponse.data.column.model;
              } else {
                self.dataTableFeedback = [];
                self.chartPie.series[0].data = null;
                self.chartColumn.series = [];
                self.chartColumn.xAxis.categories = [];
                self.totalTable = 0;
                self.searchTotalTable = 0;
              }
            } else {
              self.dataTableFeedback = [];
              self.searchTotalTable = 0;
              self.totalTable = 0;
            }
            self.loading = false;
            self.isSearch = false;
            self.isFirst = false;
            self.dataTableFeedback.forEach((element) => {
              element.show = self.ShowAllText;
            });
          },
          (errorResource) => {
            self.loading = false;
            self.isSearch = false;
            console.error(errorResource);
          }
        );
      } else {
        self.$swal.fire({
          icon: "warning",
          title: self.$t("warning"),
          text: "Please fill Start Date and End Date!",
          showConfirmButton: false,
          timer: 2000,
        });
        self.loading = false;
        return;
      }
    },
    ExportReportFeedback() {
      let self = this;
      self.loading = true;
      if (self.startDate != null && self.endDate != null) {
        let temp = {
          StartDate: self.startDate,
          EndDate: self.endDate,
        };
        self.$call.ExportReportFeedback(
          temp,
          (dataResponse) => {
            if (dataResponse) {
              let fileURL = window.URL.createObjectURL(
                new Blob([dataResponse])
              );
              let fileLink = document.createElement("a");

              fileLink.href = fileURL;

              let fileNameshow = `ReportFeedback__${
                self.convertDateToString2(self.startDate, "") +
                "-" +
                self.convertDateToString2(self.endDate, "")
              }.xlsx`;
              fileLink.setAttribute("download", fileNameshow);
              document.body.appendChild(fileLink);

              fileLink.click();
            }
            self.loading = false;
          },
          (errorResource) => {
            self.loading = false;
            console.error(errorResource);
          }
        );
      } else {
        self.$swal.fire({
          icon: "warning",
          title: self.$t("warning"),
          text: "Please fill the required fields!!!",
          showConfirmButton: false,
          timer: 2000,
        });
        self.loading = false;
        return;
      }
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
    convertDateToString(date, seperator = "/") {
      return dateUtils.getStringWithTimeFromDate(
        moment(date).toDate(),
        seperator
      );
    },
    convertDateToString2(date, seperator = "-") {
      return dateUtils.getStringFromDatePickFormatDatePick2(
        moment(date).toDate(),
        seperator
      );
    },
    substringLong(value) {
      if (value == null) {
        return "-";
      }
      if (value.length > 4000) {
        return value.substring(0, 3999) + ".....";
      }
      return value;
    },
    ShowAll() {
      let self = this;
      self.ShowAllText = !self.ShowAllText;
      self.dataTableFeedback.forEach((element) => {
        element.show = self.ShowAllText;
      });
    },
    CloseShowAll() {
      let self = this;
      self.ShowAllText = !self.ShowAllText;
      self.dataTableFeedback.forEach((element) => {
        element.show = self.ShowAllText;
      });
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
  },
  computed: {
    headers() {
      return [
        { title: this.$t("no"), value: "no", align: "center", sortable: false },
        {
          title: this.$t("Questions"),
          value: "text",
          align: "center",
          sortable: false,
        },
        {
          title: this.$t("Answers"),
          value: "replymsg",
          align: "center",
          sortable: false,
          width: "600px",
        },
        {
          title: this.$t("LikeDislike"),
          value: "scores",
          align: "center",
          sortable: false,
        },
        {
          title: this.$t("Comments"),
          value: "comments",
          align: "center",
          sortable: false,
        },
      ];
    },
  },
  mounted() {
    let self = this;
    // self.loadingCard = true;
    self.GetDate();
    var date = new Date();
    self.endDate = self.convertDateToString2(date);
    self.startDate = self.convertDateToString2(date);
    self.GetTableReportFeedback();
    self.isInitialized = true;
  },
};
</script>
<style scoped>
/* Chart Cards */
.reportdata-feedback-chart-card {
  border-radius: 12px !important;
  margin-bottom: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  overflow: hidden;
}

/* Table Specific Styles */
.reportdata-feedback-table {
  border-radius: 0 !important;
}

.reportdata-feedback-table :deep(.v-data-table__th) {
  white-space: nowrap;
  font-weight: 600;
  background-color: rgba(25, 118, 210, 0.02);
}

/* Text Content Containers */
.reportdata-feedback-text-container {
  padding: 8px 0;
  max-width: 100%;
  word-break: break-word;
  overflow-wrap: break-word;
}

.reportdata-feedback-answer-container {
  display: flex;
  align-items: flex-start;
  max-width: 400px;
}

.reportdata-feedback-answer-content {
  flex: 1;
  margin-right: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  transition: all 0.3s ease;
}

.reportdata-feedback-answer-content.expanded {
  -webkit-line-clamp: unset;
  display: block;
}

.reportdata-feedback-toggle-btn {
  flex-shrink: 0;
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.reportdata-feedback-toggle-btn:hover {
  opacity: 1;
}
</style>
